import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { isMobile } from 'react-device-detect';

import { getActiveLanguageCode } from 'services/i18nService';

import { PORNDOE_BRAND_TYPE } from './helpers';
import { bannerImagesURLs } from './images';
import styles from './index.css';


export default class TokenBannerPorndoe extends PureComponent {
  static propTypes = {
    porndoeBrand: PropTypes.oneOf([
      PORNDOE_BRAND_TYPE.AMATEUREURO,
      PORNDOE_BRAND_TYPE.DOEGIRLS,
      PORNDOE_BRAND_TYPE.LETSDOEIT,
      PORNDOE_BRAND_TYPE.MAMACITAZ,
      PORNDOE_BRAND_TYPE.SUPERBE,
      PORNDOE_BRAND_TYPE.TRANSBELLA,
      PORNDOE_BRAND_TYPE.VIPSEXVAULT,
    ]).isRequired,
  };

  render() {
    const { porndoeBrand } = this.props;

    const device = isMobile ? 'mobile' : 'desktop';
    const brandUrls = bannerImagesURLs[device][porndoeBrand];
    if (!brandUrls) {
      return null;
    }

    const activeLanguageCode = getActiveLanguageCode();
    const url = brandUrls[activeLanguageCode] || brandUrls.en;

    return (
      <img
        alt=""
        className={styles.bannerImage}
        src={url}
      />
    );
  }
}
